export default ({
  start = undefined,
  end = undefined,
  field = 'lastModifiedDate',
} = {}) => ({
  start,
  end,
  field,
});
